import gql from "graphql-tag";

const QUESTION_QUERY = gql`
  query QUESTION_QUERY($slug: String) {
    question(where: { slug: $slug }) {
      id
      title
      body
      createdAt
      ratedUpKnowledgeItems {
        id
        createdBy {
          id
        }
      }
      tags {
        id
        label
      }
      ratedDownKnowledgeItems {
        id
        createdBy {
          id
        }
      }
      type {
        label
      }
      slug
      poster {
        id
        firstName
        profilePic
      }
      tags {
        id
        label
      }
      answers(where: { blocked: false }) {
        id
        body
        createdAt
        poster {
          firstName
          profilePic
          id
        }
        ratedUpKnowledgeItems {
          id
          createdBy {
            id
          }
        }
        ratedDownKnowledgeItems {
          id
          createdBy {
            id
          }
        }
        markedCorrect
        blocked
      }
    }
  }
`;

module.exports = QUESTION_QUERY;
